import { render, staticRenderFns } from "./CertificatesCap.vue?vue&type=template&id=683284db&scoped=true"
import script from "./CertificatesCap.vue?vue&type=script&lang=js"
export * from "./CertificatesCap.vue?vue&type=script&lang=js"
import style0 from "./CertificatesCap.vue?vue&type=style&index=0&id=683284db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@6.26.3_css-loader@6.11.0_webpack_0adae5f353b25b49b54638f9fc4b63b8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683284db",
  null
  
)

export default component.exports